import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { BodyPrimary, BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import { getItemSummarySellerId, getItemSummarySellerName } from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { getSellerUrl } from '@/utils/urls';

export type ItemCardAuctionNameProps = {
    itemId: number;
    onNavigate?: () => void;
    showFullAuctionName?: boolean;
    usePrimary?: boolean;
};

export const ItemCardAuctionName = ({
    itemId,
    onNavigate,
    showFullAuctionName,
    usePrimary = false,
}: ItemCardAuctionNameProps) => {
    const formatMessage = useAppFormatMessage();
    const sellerId = useAppSelector((state) => getItemSummarySellerId(state, itemId));
    const sellerName = useAppSelector((state) => getItemSummarySellerName(state, itemId));

    const TextComponent = usePrimary ? BodyPrimary : BodySecondary;

    return (
        <span className="max-w-[50%] flex-grow truncate text-right">
            {sellerName ? (
                <TextComponent>
                    <SubtleMonochromeLink
                        className={cn('text-text-secondary no-underline', !showFullAuctionName && 'xsMax:max-w-[82px]')}
                        href={getSellerUrl(sellerId, sellerName)}
                        onClick={() => onNavigate?.()}
                    >
                        {sellerName}
                    </SubtleMonochromeLink>
                </TextComponent>
            ) : (
                <span className="flex text-text-secondary">{formatMessage(['no_auctioneer_name'])}</span>
            )}
        </span>
    );
};
